import { Component, OnDestroy, signal, TemplateRef, ViewChild } from '@angular/core';
import { CompanyService } from '../../configuration/company/company.service.service';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { getCode } from 'app/utils/method';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import { IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import DistributionChainAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity';
import { DistributionChainService } from '../../configuration/distribution-chain/distribution-chain.service';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import { SalesOfficeService } from '../../configuration/sales-office/sales-office.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ICreateMemberNotification, IUpdateMemberNotification } from './interfaces/member-interface';
import { MemberNotificationService } from './n-member.service';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { DeleteConfirmationComponent } from '../../business-partners/business-partner/delete-modal/delete-modal.component';
import { MatTabsModule } from '@angular/material/tabs';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import NotificationMemberAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-member/notification-member.entity';
import { NotificationsFiltersComponent } from '../../filters/notifications-filters/notifications-filters.component';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: 'app-n-member',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    MatTabsModule,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    FilterComponent,
    HoverMenuDirective
  ],
  templateUrl: './n-member.component.html',
  styleUrl: './n-member.component.scss'
})
export class NMemberComponent implements OnDestroy{
  getCode = getCode
  displayedColumns: string[] = [
    "name",
    "company",
    "statusId", 
    "action"
  ];

  dataSource = new MatTableDataSource<any>([]);
  members = signal<any[]>([]);
  
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof any = "company";
  sortDirection: "ASC" | "DESC" = "ASC";

  companyList: CompanyAttributes[] = []
  companyFilterList: CompanyAttributes[] = [];

  currentMemberN: ICreateMemberNotification = this.initializeCreateGroup();
  public id: any = null

  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;

  openFormAddEmailNotificactionMember = false;  
  editDetailEmailNotificactionMember = false;

  currentCreateEmailNotificactionMember:string = null;

  openFormAddPhoneNotificactionMember = false;  
  editDetailPhoneNotificactionMember = false;

  currentCreatePhoneNotificactionMember:string = null;

  emailList: any[] = []
  phoneList: any[] = []

  searchSubscription: Subscription;

  selectedStatuses: number[] = [];

  form: FormGroup;
  
  constructor(
    private memberNotificationService: MemberNotificationService,
    private readonly companyService: CompanyService,
    private readonly distributionChainService: DistributionChainService,  
    private readonly salesOfficeService: SalesOfficeService, 
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private fb: FormBuilder
  ) { 
    this.form = this.fb.group({
      companyId: [],
      distributionChainId: [],
      salesOfficeId: []
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.getList();
  }

  applyFilter(filterNotificactionMember: string) {
    this.pageIndex = 1
    this.search = filterNotificactionMember
    this.getList()
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  getList(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    let dataToFilter: IFilters = {
      companyId: this.form.get("compnayId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      distributionChainId: this.form.get("distributionChainId")?.value,
      status: this.selectedStatuses
    }

    this.memberNotificationService.getAllPaginate(options,
      dataToFilter
    ).subscribe({
      next: (res: IPaginationResult<any>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener grupos","Cerrar",{ duration: 5000});
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  private initializeCreateGroup(): ICreateMemberNotification {
    return { 
      code: "", 
      externalKey: null,
      name: null,
      email: [],
      phone: [],
      companyId: null,
     // distributionChainId: null,
      //salesOfficeId: null,
      members: null
    };
  }

  //start filter
  getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        this.companyFilterList = this.companyList.slice();
      },
      error: (err) => {
        this.snackBar.open('no se encontraron compañias.', 'Cerrar', { duration: 3000 });
      }
    });
  }

  openModal(memberN?: any): void {
    this.getAllCompanies()
    //this.fetchAllDistributionChain()
    this.emailList = [];
    this.phoneList = [];
  

  this.currentCreateEmailNotificactionMember = null;
  this.currentCreatePhoneNotificactionMember = null;
  this.openFormAddEmailNotificactionMember = false;
  this.editDetailEmailNotificactionMember = false;
  this.openFormAddPhoneNotificactionMember = false;
  this.editDetailPhoneNotificactionMember = false;

  if(memberN){
    this.currentMemberN = {
      ...memberN,
      code: memberN.code, //no debo mandar
      externalKey: this.getCode(memberN) ? this.getCode(memberN) : null,
      companyId: memberN.company ? memberN.company._id.toString() : "",
      //distributionChainId: memberN.distributionChain ? memberN.distributionChain._id.toString() : null,
      //salesOfficeId: memberN.salesOffice ? memberN.salesOffice._id.toString() : null,
    };
    this.id = memberN._id
    //this.getAllSalesOfficeList(memberN.company._id.toString());
    this.emailList = memberN.email.length > 0 ? memberN.email.map(e => ({ email: e, isEditMode: false, })) : [];
    this.phoneList = memberN.phone.length > 0 ? memberN.phone.map(e => ({ phone: e, isEditMode: false, })) : [];

  }else{
    this.currentMemberN = this.initializeCreateGroup();
    this.id = null
  }

  this.dialogRef = this.dialog.open(this.actionModal, { width: '65%', disableClose: true })
  this.dialogRef.afterClosed().subscribe((result) => { result });
}

  onClearEvent() {
    this.selectedStatuses = [];
    this.form.reset();
    this.pageIndex = 1;
    this.getList();
  }

  onSubmit(){
    if(this.id == null){
      this.createMemberN()
    }else{
      this.updateMemberN(this.id)
    }
  }

  createMemberN(): void {
    const dataToSend:any = Object.entries(this.currentMemberN)
    .reduce((acc, [key, NotificactionMember]) => {
      if (NotificactionMember !== '' && NotificactionMember!==null && !(Array.isArray(NotificactionMember) && NotificactionMember.length === 0)) { 
        acc[key] = NotificactionMember;
      }
      return acc;
    }, {});

    dataToSend.email = this.emailList.length > 0 ? this.emailList.map(e => e.email) : [];
    dataToSend.phone = this.phoneList.length > 0 ? this.phoneList.map(e => e.phone) : [];
    dataToSend.statusId = 1; // Activar por defecto al crear

    this.memberNotificationService.create(dataToSend).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        if(this.dialogRef){
          this.dialogRef.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateMemberN(id: string): void {
   if (this.currentMemberN) {
      const updatedMemberN: IUpdateMemberNotification = {
        name: this.currentMemberN.name ?? null,
        phone: [],
        email: [],
        companyId: this.currentMemberN.companyId ?? null,
       // distributionChainId: this.currentMemberN.distributionChainId ?? null,
        //salesOfficeId: this.currentMemberN.salesOfficeId ?? null,
        statusId: this.currentMemberN.statusId ?? 1
      };

      updatedMemberN.email = this.emailList.length > 0 ? this.emailList.map(e => e.email) : [];
      updatedMemberN.phone = this.phoneList.length > 0 ? this.phoneList.map(e => e.phone) : [];

      this.memberNotificationService.update(id, updatedMemberN).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          if(this.dialogRef){
            this.dialogRef.close(true);
          }
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, memberN: any): void {
    const originalStatusId = memberN.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedMemberN = { 
      ...memberN, 
      statusId: updatedStatusId 
    };

    this.memberNotificationService.update(memberN._id.toString(), updatedMemberN).subscribe({
      next: () => {
        this.getList();
        memberN.statusId = updatedStatusId; 
        this.snackBar.open(
        `Miembro ${updatedStatusId === 1 ? 'activado' : 'desactivado'} con éxito`,
        'Cerrar',
        { duration: 3000 }
      );
      },
      error: () => {
        memberN.statusId = originalStatusId;
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });
  }

  openDeleteDialog(memberN: any): void {
    this.dialog
      .open(this.deleteDialog, { data: memberN, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(memberN._id.toString()));
  }

  delete(id: string): void {
    this.memberNotificationService.remove(id).subscribe(() => {
      this.getList();
      
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

 
  private isEmailDuplicatedLocally(email: string): boolean {
    const normalizedEmail = email.trim().toLowerCase();
    return this.emailList.some(item => item.email.trim().toLowerCase() === normalizedEmail);
  }

 
  private isPhoneDuplicatedLocally(phone: string): boolean {
    const normalizedPhone = phone.trim();
    return this.phoneList.some(item => item.phone.trim() === normalizedPhone);
  }


  private isEmailDuplicatedGlobally(email: string): boolean {
    const normalizedEmail = email.trim().toLowerCase();
    return this.dataSource.data.some(member => {
      // Excluir el miembro actual si estamos editando
      if (this.id && member._id === this.id) return false;
      
      return member.email && member.email.some(memberEmail => 
        memberEmail.trim().toLowerCase() === normalizedEmail
      );
    });
  }


  private isPhoneDuplicatedGlobally(phone: string): boolean {
    const normalizedPhone = phone.trim();
    return this.dataSource.data.some(member => {
      if (this.id && member._id === this.id) return false;
      
      return member.phone && member.phone.some(memberPhone => 
        memberPhone.trim() === normalizedPhone
      );
    });
  }


  private isEmailDuplicated(email: string): boolean {
    return this.isEmailDuplicatedLocally(email) || this.isEmailDuplicatedGlobally(email);
  }


  private isPhoneDuplicated(phone: string): boolean {
    return this.isPhoneDuplicatedLocally(phone) || this.isPhoneDuplicatedGlobally(phone);
  }

  onAddToListEmailNotificactionMember(){
    if(this.currentCreateEmailNotificactionMember == null || this.currentCreateEmailNotificactionMember.trim() == ''){
      this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {duration: 5000, verticalPosition: "top"});
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.currentCreateEmailNotificactionMember)) {
      this.snackBar.open("Ingrese un correo válido", "Cerrar", {
        duration: 5000,
        verticalPosition: "top"
      });
      return;
    }

    if (this.isEmailDuplicatedLocally(this.currentCreateEmailNotificactionMember)) {
      this.snackBar.open("Este correo ya ha sido agregado a este miembro", "Cerrar", {
        duration: 5000,
        verticalPosition: "top"
      });
      return;
    }

    if (this.isEmailDuplicatedGlobally(this.currentCreateEmailNotificactionMember)) {
      this.snackBar.open("Este correo ya está siendo usado por otro miembro", "Cerrar", {
        duration: 5000,
        verticalPosition: "top"
      });
      return;
    }

    this.emailList.push({email: this.currentCreateEmailNotificactionMember.trim(), isEditMode: false});
    this.openFormAddEmailNotificactionMember = false;
    this.currentCreateEmailNotificactionMember = null;
  }

  onUpdateEmailNotificactionMember(result){
    result.originalEmail = result.email; 
    result.isEditMode = true;
  }

  onSaveEmailNotificactionMember(element){
    if(element.email == null || element.email.trim() == '' ){
      this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {duration: 5000, verticalPosition: "top"});
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(element.email)) {
      this.snackBar.open("Ingrese un correo válido", "Cerrar", {
        duration: 5000,
        verticalPosition: "top"
      });
      return;
    }

    const currentEmail = element.email.trim().toLowerCase();
    const originalEmail = element.originalEmail ? element.originalEmail.trim().toLowerCase() : '';
    
    if (currentEmail !== originalEmail) {
      const isDuplicatedLocally = this.emailList.some(item => 
        item !== element && item.email.trim().toLowerCase() === currentEmail
      );

      if (isDuplicatedLocally) {
        this.snackBar.open("Este correo ya ha sido agregado a este miembro", "Cerrar", {
          duration: 5000,
          verticalPosition: "top"
        });
        return;
      }

      if (this.isEmailDuplicatedGlobally(element.email)) {
        this.snackBar.open("Este correo ya está siendo usado por otro miembro", "Cerrar", {
          duration: 5000,
          verticalPosition: "top"
        });
        return;
      }
    }

    element.email = element.email.trim();
    element.isEditMode = false;
    delete element.originalEmail;
  }

  openDeleteEmailNotificactionMember(element, index){
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: element,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if(result){
          this.emailList.splice(index, 1);
        }
      });
  }

  onAddToListPhoneNotificactionMember(){
    if(this.currentCreatePhoneNotificactionMember == null || this.currentCreatePhoneNotificactionMember.trim() == ''){
      this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {duration: 5000, verticalPosition: "top"});
      return;
    }

    const phoneRegex = /^[0-9]+$/;
    if (!phoneRegex.test(this.currentCreatePhoneNotificactionMember.trim())) {
      this.snackBar.open("Ingrese un número de teléfono válido", "Cerrar", {
        duration: 5000,
        verticalPosition: "top"
      });
      return;
    }

    if (this.isPhoneDuplicatedLocally(this.currentCreatePhoneNotificactionMember)) {
      this.snackBar.open("Este número de teléfono ya ha sido agregado a este miembro", "Cerrar", {
        duration: 5000,
        verticalPosition: "top"
      });
      return;
    }

    if (this.isPhoneDuplicatedGlobally(this.currentCreatePhoneNotificactionMember)) {
      this.snackBar.open("Este número de teléfono ya está siendo usado por otro miembro", "Cerrar", {
        duration: 5000,
        verticalPosition: "top"
      });
      return;
    }

    this.phoneList.push({phone: this.currentCreatePhoneNotificactionMember.trim(), isEditMode: false});
    this.openFormAddPhoneNotificactionMember = false;
    this.currentCreatePhoneNotificactionMember = null;
  }

  onUpdatePhoneNotificactionMember(result){
    result.originalPhone = result.phone; 
    result.isEditMode = true;
  }

  onSavePhoneNotificactionMember(element){
    if(element.phone == null || element.phone.trim() == '' ){
      this.snackBar.open("Ingrese los datos que faltan", "Cerrar", {duration: 5000, verticalPosition: "top"});
      return;
    }

    const phoneRegex = /^[0-9]+$/;
    if (!phoneRegex.test(element.phone.trim())) {
      this.snackBar.open("Ingrese un número de teléfono válido", "Cerrar", {
        duration: 5000,
        verticalPosition: "top"
      });
      return;
    }

    const currentPhone = element.phone.trim();
    const originalPhone = element.originalPhone ? element.originalPhone.trim() : '';
    
    if (currentPhone !== originalPhone) {
      const isDuplicatedLocally = this.phoneList.some(item => 
        item !== element && item.phone.trim() === currentPhone
      );

      if (isDuplicatedLocally) {
        this.snackBar.open("Este número de teléfono ya ha sido agregado a este miembro", "Cerrar", {
          duration: 5000,
          verticalPosition: "top"
        });
        return;
      }

      if (this.isPhoneDuplicatedGlobally(element.phone)) {
        this.snackBar.open("Este número de teléfono ya está siendo usado por otro miembro", "Cerrar", {
          duration: 5000,
          verticalPosition: "top"
        });
        return;
      }
    }

    element.phone = element.phone.trim();
    element.isEditMode = false;
    delete element.originalPhone;
  }

  openDeletePhoneNotificactionMember(element, index){
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: element,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if(result){
          this.phoneList.splice(index, 1);
        }
      });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}